import React, { Component, Fragment } from "react";
import { getLoggedInUser } from "../../../MainPage/UserInfo";
import { CRUDFunction } from "../../../../reduxCURD/container";
import ConfirmationDialog from "../../../../libraries/ConfirmationDialog";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import { ToastService } from "../../../../utils/toastify";
import { withRouter } from "react-router-dom";
import permissionCheck from "../../../../utils/permissionCheck";

const user = getLoggedInUser();

class CertifyBlueCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationDialog: null,
    };

    this.shouldDisableCertify = this.shouldDisableCertify.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "CERTIFYBLUECARD_UPDATE_SUCCESS") {
      ToastService.Success("Certified Successfully");
      this.props.handleCertifyClick();
    }

    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "CERTIFYBLUECARD_UPDATE_FAILURE") {
      ToastService.Error("Error:", "Certify Error");
      this.props.handleCertifyClick();
    }
  }

  CertifyBlueCard = () => {
    const payload = {
      certifiedBy: {
        id: user._id.toString(),
        name: user.name,
        email: user.email,
      },
      assetId: this.props.assetId,
      year: this.props.year,
    };
    this.props.updateCertifyBlueCard(payload, "certifyBlueCardTest");
    this.closeConfirmationDialog();
  };

  openConfirmationDialog = () => {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title="Confirm"
          body={<Fragment>Are you sure you want to certify?</Fragment>}
          action="oouCertify"
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={this.CertifyBlueCard}
        />
      ),
    });
  };

  closeConfirmationDialog = () => {
    this.setState({ confirmationDialog: null });
  };

  shouldDisableCertify() {
    const allowCertify = permissionCheck("BLUECARD YEAR", "certify");
    const areTestsPending = this.props.pendingReviewDetails && this.props.pendingReviewDetails.disabledForCertification;
    return areTestsPending || !allowCertify || !user.highlyQualified;
  }

  render() {
    const disableCertify = this.shouldDisableCertify();
    return (
      <div>
        {this.state.confirmationDialog}
        {this.props.certifiedBy //if certified then show certified by name
          ? this.props.certifiedBy.name
            ? this.props.certifiedBy.name
            : this.props.certifiedBy
          : this.props.blueCardReview && (
              <MyButton
                className="no-print blueCardFooterReport oouCertifyFormatter"
                style={{ backgroundColor: "var(--nine)", borderRadius: "5px", padding: "2px 30px", fontSize: "18px", marginBottom: "8px" }}
                onClick={this.openConfirmationDialog}
                disabled={disableCertify}
              >
                Certify
              </MyButton>
            )}
      </div>
    );
  }
}
let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
};

const CertifyBlueCardContainer = CRUDFunction(CertifyBlueCard, "CertifyBlueCard", actionOptions, null, null, "blueCard");

export default withRouter(CertifyBlueCardContainer);



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/CertifyTest/CertifyBlueCard.jsx